export default [
  // {
  //   path: '/buying/ancillary',
  //   name: 'BuyingTariffAncillaryRate',
  //   component: () => import('@/components/master/buyingTariff/AncillaryRate'),
  //   meta: {
  //     title: 'Operator Tariff - Ancillary Rate',
  //     requiresAuth: true,
  //     services: ['BuyingTariffAncillaryRate']
  //   }
  // },
  {
    path: "/buying/chauffeur",
    name: "BuyingTariffRentalChauffeurRate",
    component: () =>
      import("@/components/master/buyingTariff/RentalChauffeurRate"),
    meta: {
      title: "Operator Tariff - Chauffeur Rate",
      requiresAuth: true,
      services: ["BuyingTariffRentalChauffeurRate"]
    }
  },
  {
    path: "/buying/hourly-chauffeur",
    name: "BuyingTariffRentalChauffeurRate",
    component: () =>
      import("@/components/master/buyingTariff/HourlyChauffeurBuying"),
    meta: {
      title: "Operator Tariff - Chauffeur Rate",
      requiresAuth: true,
      services: ["BuyingTariffRentalChauffeurRate"]
    }
  },
  {
    path: "/buying/hourly-chauffeur/:masterClassId",
    name: "BuyingTariffRentalChauffeurRate",
    component: () =>
      import("@/components/master/buyingTariff/HourlyChauffeurRateBuying"),
    meta: {
      title: "Operator Tariff - Chauffeur Rate",
      requiresAuth: true,
      services: ["BuyingTariffRentalChauffeurRate"]
    }
  },
  {
    path: "/buying/selfdrive",
    name: "BuyingTariffRentalSelfDriveRate",
    component: () =>
      import("@/components/master/buyingTariff/RentalSelfDriveRate"),
    meta: {
      title: "Operator Tariff - Self Drive Rate",
      requiresAuth: true,
      services: ["BuyingTariffRentalSelfDriveRate"]
    }
  },
  // {
  //   path: "/buying/transfer",
  //   name: "BuyingTariffTransferRate",
  //   component: () => import("@/components/master/buyingTariff/TransferRate"),
  //   meta: {
  //     title: "Operator Tariff - Transfer Rate",
  //     requiresAuth: true,
  //     services: ["BuyingTariffTransferRate"]
  //   }
  // },
  {
    path: "/buying/transfer",
    name: "BuyingTariffTransferRate",
    component: () =>
      import("@/components/master/buyingTariff/TransferClassList"),
    meta: {
      title: "Operator Tariff - Transfer Rate",
      requiresAuth: true,
      services: ["BuyingTariffTransferRate"]
    }
  },
  {
    path: "/buying/transfer/:masterClassId",
    name: "BuyingTariffTransferRate",
    component: () =>
      import("@/components/master/buyingTariff/TransferRateList"),
    meta: {
      title: "Operator Tariff - Transfer Rate",
      requiresAuth: true,
      services: ["BuyingTariffTransferRate"]
    }
  },
  {
    path: "/buying/surcharge",
    name: "BuyingTariffSurcharge",
    component: () => import("@/components/master/buyingTariff/Surcharge"),
    meta: {
      title: "Operator Tariff - Surcharge",
      requiresAuth: true,
      services: [
        "BuyingTariffGeneralSurcharge",
        "BuyingTariffCancellationSurcharge",
        "BuyingTariffPeakPeriodSurcharge",
        "BuyingTariffWaitingTimeSurcharge"
      ]
    }
  },
  {
    path: "/buying/chauffeur/override",
    name: "BuyingTariffOverriddenRentalChauffeurRate",
    component: () =>
      import("@/components/master/buyingTariff/OverriddenRentalChauffeurRate"),
    meta: {
      title: "Operator Tariff - Overridden Chauffeur Rate",
      requiresAuth: true,
      services: ["BuyingTariffOverriddenRentalChauffeurRate"]
    }
  },
  {
    path: "/buying/selfdrive/override",
    name: "BuyingTariffOverriddenRentalSelfDriveRate",
    component: () =>
      import("@/components/master/buyingTariff/OverriddenRentalSelfDriveRate"),
    meta: {
      title: "Operator Tariff - Overridden Self Drive Rate",
      requiresAuth: true,
      services: ["BuyingTariffOverriddenRentalSelfDriveRate"]
    }
  },
  {
    path: "/buying/transfer/override",
    name: "BuyingTariffOverriddenTransferRate",
    component: () =>
      import("@/components/master/buyingTariff/OverriddenTransferRate"),
    meta: {
      title: "Operator Tariff - Overridden Transfer Rate",
      requiresAuth: true,
      services: ["BuyingTariffOverriddenTransferRate"]
    }
  },
  {
    path: "/buying/surcharge/override",
    name: "BuyingTariffOverriddenSurcharge",
    component: () =>
      import("@/components/master/buyingTariff/OverriddenSurcharge"),
    meta: {
      title: "Operator Tariff - Overridden Surcharge",
      requiresAuth: true,
      services: [
        "BuyingTariffOverriddenGeneralSurcharge",
        "BuyingTariffOverriddenCancellationSurcharge",
        "BuyingTariffOverriddenPeakPeriodSurcharge",
        "BuyingTariffOverriddenWaitingTimeSurcharge"
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/buyingTariffModule.js